enum LoanPaymentAbasActionsEnum {
    LoanPaymentAbaGet = 'LOAN_PAYMENT_ABA/GET',
    LoanPaymentAbaSet = 'LOAN_PAYMENT_ABA/SET',

    LoanPaymentAbaHistoriesList = 'LOAN_PAYMENT_ABA/HISTORIES/LIST',
    LoanPaymentAbaHistoriesSet = 'LOAN_PAYMENT_ABA/HISTORIES/SET',

    LoanPaymentAbaWarehouseLoanTransactionsList = 'LOAN_PAYMENT_ABA/WAREHOUSE_LOAN_TRANSACTIONS/LIST',
    LoanPaymentAbaWarehouseLoanTransactionsSet = 'LOAN_PAYMENT_ABA/WAREHOUSE_LOAN_TRANSACTIONS/SET',

    LoanPaymentAbasAdd = 'LOAN_PAYMENT_ABAS/ADD',
    LoanPaymentAbasList = 'LOAN_PAYMENT_ABAS/LIST',
    LoanPaymentAbasSet = 'LOAN_PAYMENT_ABAS/SET',

    LoanPaymentAbasUnallocatedWarehouseLoanTransactionsClear = 'LOAN_PAYMENT_ABAS/UNALLOCATED_WAREHOUSE_LOAN_TRANSACTIONS/CLEAR',
    LoanPaymentAbasUnallocatedWarehouseLoanTransactionsList = 'LOAN_PAYMENT_ABAS/UNALLOCATED_WAREHOUSE_LOAN_TRANSACTIONS/LIST',
    LoanPaymentAbasUnallocatedWarehouseLoanTransactionsSet = 'LOAN_PAYMENT_ABAS/UNALLOCATED_WAREHOUSE_LOAN_TRANSACTIONS/SET',
}

export default LoanPaymentAbasActionsEnum;
